import styled from 'styled-components';
import { Row } from 'styles';

export const TextWrapper = styled.div`
  margin-bottom: 30px;
`;

export const RowWrapper = styled(Row)<StyleProps>`
  cursor: pointer;
`;
